// import { HttpHeaders } from '@angular/common/http/src/headers';
// import { HttpHeaders } from '@angular/common/http';
// import {Observable} from 'rxjs/Rx';
// import { ClassSchedule } from '../models/class-schedule';
import { Injectable } from '@angular/core';
import { Http, Headers, RequestOptions } from '@angular/http';
import 'rxjs/add/operator/map';
import { StudentPost } from '../models/student-post';
import { StudentGet } from '../models/student-get';
import { environment } from '../../environments/environment';

@Injectable()
export class StudentService {

  private _studentUrl: string = `${environment.apiRootURL}/students`;
  private _classUrl: string = `${environment.apiRootURL}/sessions`;
  private _classScheduleUrl: string = `${environment.apiRootURL}/classSchedules`;
  private _student: StudentGet = new StudentGet();

  constructor(
    private _http: Http,
    ) { }

  saveStudent(student: StudentPost) {
    const options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('Content-Type', 'application/json');
    console.log('Http POST student');
    return this._http.post(`${this._studentUrl}`, JSON.stringify(student), options).map(response => response.json());
  }

  updateStudentEmail(student: StudentGet) {
    const options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('Content-Type', 'application/json');
    console.log('Http Patch student');
    const payload = [{'op': 'replace', 'path': '/email', value:student.email}];
    return this._http.patch(`${this._studentUrl}/${student.id}`, JSON.stringify(payload), options).map(response => response.json());
  }

  updateStudentContactMethod(student: StudentGet) {
    const options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('Content-Type', 'application/json');
    console.log('Http Patch student');
    const payload = [{'op': 'replace', 'path': '/contactMethodId', value:student.contactMethodId}];
    return this._http.patch(`${this._studentUrl}/${student.id}`, JSON.stringify(payload), options).map(response => response.json());
  }

  checkStudentEnrollment ( studentId: string, classScheduleId: string) {
    const options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('Content-Type', 'application/json');
    console.log('Http Post studentclass');
    const localUrl = `${this._studentUrl}/${studentId}/checkStudentClass`;
    const payload = {'StudentId': studentId, 'ClassScheduleId': classScheduleId};
    return this._http.post(localUrl, JSON.stringify(payload), options).map(response => response.json());
  }

  addStudentClass( studentId: string, classScheduleId: string, amount: string, chkno: string) {
    const options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('Content-Type', 'application/json');
    console.log('Http Post studentclass');
    const localUrl = `${this._studentUrl}/${studentId}/createStudentClass`;
    const payload = {'StudentId': studentId, 'ClassScheduleId': classScheduleId
      , 'RegistrationCompletedDate': new Date().toISOString(), 'Amount': amount, 'ChkNo': chkno};
    return this._http.post(localUrl, JSON.stringify(payload), options).map(response => response.json());
  }

  getClassSchedulesByInstructor(instructorId: string) {
    const options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('Content-Type', 'application/json');
    console.log('Http Get class');
    const localUrl = `${this._classScheduleUrl}/GetClassSchedulesByInstructor/${instructorId}`;
    return this._http.get(localUrl).map(response => response.json());
  }

  GetClassSchedule(classScheduleId: string) {
    const options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('Content-Type', 'application/json');
    console.log('Http Get class');
    const localUrl = `${this._classScheduleUrl}/${classScheduleId}/GetClassSchedule`;
    return this._http.get(localUrl).map(response => response.json());
  }

  IsThereASeat(classScheduleId: string) {
    const options = new RequestOptions();
    options.headers = new Headers();
    options.headers.append('Content-Type', 'application/json');
    console.log('Http Get class');
    const localUrl = `${this._classUrl}/${classScheduleId}/IsThereASeat`;
    return this._http.get(localUrl).map(response => response.json());
  }

  getStudentByLogin(studentId: string, loginId: string) {
    let aurl = '';
    if (studentId != null) {
      aurl = `${this._studentUrl}/${studentId}`;
    } else {
      aurl = `${this._studentUrl}/getStudentByLogin/id/${loginId}`;
    }
    console.log('HTTP GET ' + aurl);
    const astudent = this._http.get(aurl).map(response => response.json());
    return astudent;
  }

  getStudentsInClass(classSessionId: string) {
    let aurl = `${this._studentUrl}/getStudentInClass/${classSessionId}`;
    console.log('HTTP GET ' + aurl);
    return this._http.get(aurl).map(response => response.json());
  }

  getStudentClasses(studentid: string) {
    const aurl = `${this._studentUrl}/${studentid}/studentClasses`;
    console.log('HTTP GET ' + aurl);
    return this._http.get(aurl).map(response => response.json());
  }

  studentSearch(searchString: string) {
    const aurl = `${this._studentUrl}/StudentSearch/${searchString}`;
    console.log('HTTP GET ' + aurl); 
    return this._http.get(aurl).map(response => response.json());
  }

  getStudentClass(studentid: string, studentclassid: string) {
    const aurl = `${this._studentUrl}/${studentid}/studentClasses/${studentclassid}`;
    console.log('HTTP GET ' + aurl);
    return this._http.get(aurl).map(response => response.json());
  }

  deleteStudentClass(studentid: string, studentclassid: string, amount: string) {
    const aurl = `${this._studentUrl}/${studentid}/studentClasses/${studentclassid}/${amount}`;
    console.log('HTTP DELETE ' + aurl);
    return this._http.delete(aurl).map(response => response.json());
  }

  UpdateStudentLatLong( studentId: string, latitude: string, logitude: string) {
    const aurl = `${this._studentUrl}/updateStudentLatLong/${studentId}/lat/${latitude}/long/${logitude}`;
    console.log('HTTP GET ' + aurl);
    return this._http.get(aurl).map(response => response.json());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/student.service.ts